export interface LoggingType {
  type: LogTarget;
  level: LogLevel;
}

export type LogLevel = 'error' | 'warning' | 'debug' | 'info' | 'none';
export type LogTarget = 'console' | 'server' | 'none';

export enum LoggerEndpoint {
  Event = 'event',
  UniqueEvent = 'uniqueEvent',
  Duration = 'duration',
  Failure = 'failure',
}

export interface ILogPayloadBase {
  timestamp: string | number;
  additional: string;
  environment: string;
  application: string;
  location: string;
  casino: string | null;
  os: string;
  browser: string;
  version: string;
  width: number;
  height: number;
  bandwidth: number;
}

export interface IEventPayload extends ILogPayloadBase {
  count: number;
  metric: string;
}

export interface IDurationPayload extends ILogPayloadBase {
  duration: number;
  metric: string;
}

export interface IUniqueEventPayload {
  timestamp: number;
  userId: string;
  metric: string;
  payload: string;
  numberPayload: number | null;
  casino: string | null;
  location: string;
  application: string;
  appVersion?: string;
  environment: string;
  count: number;
}

export interface IFailurePayload extends ILogPayloadBase {
  count: number;
  type: string;
  place: string;
}

export enum BatchCategories {
  Events = 'events',
  Durations = 'durations',
  Failures = 'failures',
  UniqueEvents = 'uniqueEvents',
}

export interface BatchPayload {
  [BatchCategories.Events]: IEventPayload[];
  [BatchCategories.Durations]: IDurationPayload[];
  [BatchCategories.Failures]: IFailurePayload[];
  [BatchCategories.UniqueEvents]: IUniqueEventPayload[];
}

export enum VideoStatsEvent {
  VideoSessionDetails = 'video_session_details',
  VideoPlaybackDetails = 'video_playback_details',
  StorePlayerDetails = 'store_player_details',
}
